import { render, staticRenderFns } from "./PagesMainLogo.vue?vue&type=template&id=3fc6143a&scoped=true&"
import script from "./PagesMainLogo.vue?vue&type=script&lang=js&"
export * from "./PagesMainLogo.vue?vue&type=script&lang=js&"
import style0 from "./PagesMainLogo.vue?vue&type=style&index=0&id=3fc6143a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc6143a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
